module.exports = __webpack_public_path__ + "img/Millionaire-4.b2da59f7.png";